import React from 'react';
import TemplatesPanelContainer from '../../containers/templates-panel/connected';
import { useRouter } from '../../containers/view-router-context';
import { Routes } from '../../containers/view-router-context/types';

interface PageDecoratorsProps {
	hasConfluence: boolean;
	containerRef: React.RefObject<HTMLElement>;
}

export const PageDecorators = ({ hasConfluence, containerRef }: PageDecoratorsProps) => {
	const { activeRoute } = useRouter();
	if (activeRoute === Routes.ConfluenceActivatingOnDemand) {
		return null;
	}
	return <TemplatesPanelContainer hasConfluence={hasConfluence} containerRef={containerRef} />;
};
